import { create } from 'zustand';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';

interface AuthStore {
  isRememberMe: boolean;
}

interface AuthStoreActions {
  setIsRememberMe: (isRememberMe: boolean) => void;
}

export const useAuthStore = create<AuthStore & AuthStoreActions>()(
  devtools(
    persist(
      (set) => ({
        isRememberMe: false,
        setIsRememberMe: (isRememberMe: boolean) => set({ isRememberMe }),
      }),
      {
        name: 'auth-remember-storage',
        storage: createJSONStorage(() => localStorage),
      },
    ),
    {
      name: 'Auth Store',
      enabled: process.env.NEXT_PUBLIC_NODE_ENV !== 'production',
    },
  ),
);
